import { Vehicle } from '@sharedTypes/Vehicle';

interface CancelledPaymentVehicleProps {
  photo: string;
  vehicle: Vehicle;
  vehicleUrl: string;
}

const CancelledPaymentVehicle = ({
  photo,
  vehicle,
  vehicleUrl,
}: CancelledPaymentVehicleProps): JSX.Element => {
  return (
    <>
      <section className="ch-mt--3 sm:ch-mb--5 ch-container ch-bg--grey-1 confirmation-details confirmation-details--cancelled ch-pt--3 ch-ph--6">
        <div className="ch-bg--grey--1 ch-display--flex ch-flex-flow--column-nowrap">
          {photo && (
            <img
              alt=""
              className="ch-img--responsive ch-rounded--lg"
              src={photo}
            />
          )}
          <div className="ch-text--center ch-display--flex ch-flex-flow--column-nowrap ch-mt--3">
            <span className="ch-fs--3 ch-fw--500 ch-text--ellipsis">
              {vehicle.year} {vehicle.make} {vehicle.model}{' '}
            </span>
            <span className="ch-fw--400 ch-fs--2 ch-color--grey-6 ch-text--ellipsis">
              {vehicle.variant}
            </span>
          </div>
          <a className="ch-fs--3 ch-mv--3 ch-text--center" href={vehicleUrl}>
            {' '}
            View vehicle details
          </a>
        </div>
      </section>
    </>
  );
};

export default CancelledPaymentVehicle;
